export function getApiErrorMessage(error, fallback = 'Something went wrong. Try again.') {
  const data = error?.response?.data;
  if (typeof data?.message === 'string') {
    return data.message;
  }
  if (typeof data?.error === 'string') {
    return data.error;
  }
  if (data?.errors && typeof data.errors === 'object') {
    const firstField = Object.values(data.errors)[0];
    if (Array.isArray(firstField) && firstField[0]) {
      return firstField[0];
    }
  }
  if (error?.response?.status === 401) {
    return 'Session expired. Please sign in again.';
  }
  return fallback;
}
